import { render } from "./TvmColorSelection.vue?vue&type=template&id=4d057596&scoped=true"
import script from "./TvmColorSelection.js?vue&type=script&lang=js&external"
export * from "./TvmColorSelection.js?vue&type=script&lang=js&external"

import "./TvmColorSelection.vue?vue&type=style&index=0&id=4d057596&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d057596"],['__file',"src/Components/ChatWidget/TvmColorSelection/TvmColorSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d057596"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d057596', __exports__)) {
    api.reload('4d057596', __exports__)
  }
  
  module.hot.accept("./TvmColorSelection.vue?vue&type=template&id=4d057596&scoped=true", () => {
    api.rerender('4d057596', render)
  })

}


export default __exports__